import { parse, format, addDays, addWeeks, addMonths, addQuarters, addYears, startOfWeek, endOfWeek, startOfMonth, endOfMonth, startOfQuarter, endOfQuarter, startOfYear, endOfYear, differenceInCalendarDays } from 'date-fns';
import { i18n } from '@/i18n/i18n';

export const DATE_FORMAT = 'yyyy-MM-dd';

export const getTimeRangeLast7Days = () => {
    const now = new Date();
    return {
        startDate: format(addDays(now, -7), DATE_FORMAT),
        endDate: format(addDays(now, -1), DATE_FORMAT),
        compareStartDate: format(addDays(now, -14), DATE_FORMAT),
        compareEndDate: format(addDays(now, -8), DATE_FORMAT),
        label: i18n.t('timeRanges.last7Days'),
        name: 'last7Days',
    };
};
export const getTimeRangeLast14Days = () => {
    const now = new Date();
    return {
        startDate: format(addDays(now, -14), DATE_FORMAT),
        endDate: format(addDays(now, -1), DATE_FORMAT),
        compareStartDate: format(addDays(now, -28), DATE_FORMAT),
        compareEndDate: format(addDays(now, -15), DATE_FORMAT),
        label: i18n.t('timeRanges.last14Days'),
        name: 'last14Days',
    };
};
export const getTimeRangeLast30Days = () => {
    const now = new Date();
    return {
        startDate: format(addDays(now, -30), DATE_FORMAT),
        endDate: format(addDays(now, -1), DATE_FORMAT),
        compareStartDate: format(addDays(now, -60), DATE_FORMAT),
        compareEndDate: format(addDays(now, -31), DATE_FORMAT),
        label: i18n.t('timeRanges.last30days'),
        name: 'last30days',
    };
};
export const getTimeRangeToday = () => {
    const now = new Date();
    return {
        startDate: format(now, DATE_FORMAT),
        endDate: format(now, DATE_FORMAT),
        compareStartDate: format(addDays(now, -1), DATE_FORMAT),
        compareEndDate: format(addDays(now, -1), DATE_FORMAT),
        label: i18n.t('timeRanges.today'),
        name: 'today',
    };
};
export const getTimeRangeYesterday = () => {
    const now = new Date();
    return {
        startDate: format(addDays(now, -1), DATE_FORMAT),
        endDate: format(addDays(now, -1), DATE_FORMAT),
        compareStartDate: format(addDays(now, -2), DATE_FORMAT),
        compareEndDate: format(addDays(now, -2), DATE_FORMAT),
        label: i18n.t('timeRanges.yesterday'),
        name: 'yesterday',
    };
};
export const getTimeRangeCurrentWeek = () => {
    const now = new Date();
    const startOfCurrentWeek = startOfWeek(now, { weekStartsOn: 1 });
    const startOfPreviousWeek = startOfWeek(addWeeks(startOfCurrentWeek, -1), { weekStartsOn: 1 });
    return {
        startDate: format(startOfCurrentWeek, DATE_FORMAT),
        endDate: format(now, DATE_FORMAT),
        compareStartDate: format(startOfPreviousWeek, DATE_FORMAT),
        compareEndDate: format(endOfWeek(startOfPreviousWeek, { weekStartsOn: 1 }), DATE_FORMAT),
        label: i18n.t('timeRanges.currentWeek'),
        name: 'currentWeek',
    };
};
export const getTimeRangeLastWeek = () => {
    const now = new Date();
    const currentWeek = startOfWeek(now, { weekStartsOn: 1 });
    const startOfOneWeekBefore = startOfWeek(addWeeks(currentWeek, -1), { weekStartsOn: 1 });
    const startOfTwoWeeksBefore = startOfWeek(addWeeks(currentWeek, -2), { weekStartsOn: 1 });
    return {
        startDate: format(startOfOneWeekBefore, DATE_FORMAT),
        endDate: format(endOfWeek(startOfOneWeekBefore, { weekStartsOn: 1 }), DATE_FORMAT),
        compareStartDate: format(startOfTwoWeeksBefore, DATE_FORMAT),
        compareEndDate: format(endOfWeek(startOfTwoWeeksBefore, { weekStartsOn: 1 }), DATE_FORMAT),
        label: i18n.t('timeRanges.lastWeek'),
        name: 'lastWeek',
    };
};
export const getTimeRangeCurrentMonth = () => {
    const now = new Date();
    const startOfCurrentMonth = startOfMonth(now);
    const startOfPreviousMonth = startOfMonth(addMonths(startOfCurrentMonth, -1));
    return {
        startDate: format(startOfCurrentMonth, DATE_FORMAT),
        endDate: format(now, DATE_FORMAT),
        compareStartDate: format(startOfPreviousMonth, DATE_FORMAT),
        compareEndDate: format(endOfMonth(startOfPreviousMonth), DATE_FORMAT),
        label: i18n.t('timeRanges.currentMonth'),
        name: 'currentMonth',
    };
};
export const getTimeRangeLastMonth = () => {
    const now = new Date();
    const currentMonth = startOfMonth(now);
    const startOfOneMonthBefore = startOfMonth(addMonths(currentMonth, -1));
    const startOfTwoMonthsBefore = startOfMonth(addMonths(currentMonth, -2));
    return {
        startDate: format(startOfOneMonthBefore, DATE_FORMAT),
        endDate: format(endOfMonth(startOfOneMonthBefore), DATE_FORMAT),
        compareStartDate: format(startOfTwoMonthsBefore, DATE_FORMAT),
        compareEndDate: format(endOfMonth(startOfTwoMonthsBefore), DATE_FORMAT),
        label: i18n.t('timeRanges.lastMonth'),
        name: 'lastMonth',
    };
};
export const getTimeRangeCurrentQuarter = () => {
    const now = new Date();
    const startOfCurrentQuarter = startOfQuarter(now);
    const startOfPreviousQuarter = startOfQuarter(addQuarters(startOfCurrentQuarter, -1));
    return {
        startDate: format(startOfCurrentQuarter, DATE_FORMAT),
        endDate: format(now, DATE_FORMAT),
        compareStartDate: format(startOfPreviousQuarter, DATE_FORMAT),
        compareEndDate: format(endOfQuarter(startOfPreviousQuarter), DATE_FORMAT),
        label: i18n.t('timeRanges.currentQuarter'),
        name: 'currentQuarter',
    };
};
export const getTimeRangeLastQuarter = () => {
    const now = new Date();
    const currentQuarter = startOfQuarter(now);
    const startOfOneQuarterBefore = startOfQuarter(addQuarters(currentQuarter, -1));
    const startOfTwoQuartersBefore = startOfQuarter(addQuarters(currentQuarter, -2));
    return {
        startDate: format(startOfOneQuarterBefore, DATE_FORMAT),
        endDate: format(endOfQuarter(startOfOneQuarterBefore), DATE_FORMAT),
        compareStartDate: format(startOfTwoQuartersBefore, DATE_FORMAT),
        compareEndDate: format(endOfQuarter(startOfTwoQuartersBefore), DATE_FORMAT),
        label: i18n.t('timeRanges.lastQuarter'),
        name: 'lastQuarter',
    };
};
export const getTimeRangeCurrentYear = () => {
    const now = new Date();
    const startOfCurrentYear = startOfYear(now);
    const startOfPreviousYear = startOfYear(addYears(startOfCurrentYear, -1));
    return {
        startDate: format(startOfCurrentYear, DATE_FORMAT),
        endDate: format(now, DATE_FORMAT),
        compareStartDate: format(startOfPreviousYear, DATE_FORMAT),
        compareEndDate: format(endOfYear(startOfPreviousYear), DATE_FORMAT),
        label: i18n.t('timeRanges.currentYear'),
        name: 'currentYear',
    };
};
export const getTimeRangeLastYear = () => {
    const now = new Date();
    const currentYear = startOfYear(now);
    const startOfOneYearBefore = startOfYear(addYears(currentYear, -1));
    const startOfTwoYearsBefore = startOfYear(addYears(currentYear, -2));
    return {
        startDate: format(startOfOneYearBefore, DATE_FORMAT),
        endDate: format(endOfYear(startOfOneYearBefore), DATE_FORMAT),
        compareStartDate: format(startOfTwoYearsBefore, DATE_FORMAT),
        compareEndDate: format(endOfYear(startOfTwoYearsBefore), DATE_FORMAT),
        label: i18n.t('timeRanges.lastYear'),
        name: 'lastYear',
    };
};
export const getTimeRangeCustom = dates => {
    const dateFrom = format(dates[0], DATE_FORMAT);
    const dateTo = format(dates[1], DATE_FORMAT);
    const differenceInDays = differenceInCalendarDays(dateTo, dateFrom);
    return {
        startDate: dateFrom,
        endDate: dateTo,
        compareStartDate: format(addDays(dateFrom, -(differenceInDays + 1)), DATE_FORMAT),
        compareEndDate: format(addDays(dateTo, -(differenceInDays + 1)), DATE_FORMAT),
        label: `${dateFrom} - ${dateTo}`,
        name: 'custom',
    };
};

export const getDefaultTimeRange = getTimeRangeLast30Days;

export const TIME_RANGES = {
    custom: getTimeRangeCustom,
    last7Days: getTimeRangeLast7Days,
    last14Days: getTimeRangeLast14Days,
    last30days: getTimeRangeLast30Days,
    today: getTimeRangeToday,
    yesterday: getTimeRangeYesterday,
    currentWeek: getTimeRangeCurrentWeek,
    lastWeek: getTimeRangeLastWeek,
    currentMonth: getTimeRangeCurrentMonth,
    lastMonth: getTimeRangeLastMonth,
    currentQuarter: getTimeRangeCurrentQuarter,
    lastQuarter: getTimeRangeLastQuarter,
    currentYear: getTimeRangeCurrentYear,
    lastYear: getTimeRangeLastYear,
};

export const AVAILABLE_OPTIONS = Object.keys(TIME_RANGES);

export const DEFAULT_TIME_RANGE = getDefaultTimeRange();

export function dateWithoutUTC(dateString) {
    return parse(dateString, DATE_FORMAT, new Date());
}
